module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_05-c1617b18899732311d3199c5313bded2.svg";